import { render, staticRenderFns } from "./teamPage.vue?vue&type=template&id=49851ba4&scoped=true&"
import script from "./teamPage.vue?vue&type=script&lang=js&"
export * from "./teamPage.vue?vue&type=script&lang=js&"
import style0 from "./teamPage.vue?vue&type=style&index=0&id=49851ba4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49851ba4",
  null
  
)

export default component.exports